export enum DeviceIdentificationType {
    LICENSE_PLATE = 'licensePlate',
    PHONE = 'phone',
}
